export const outreachHero = {
  title: 'Community Outreach',
  subtitle: 'Bringing education, resources, and opportunities directly to underserved communities across Pulau Pinang.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Community%20outreach%20event%20in%20Malaysian%20village%2C%20volunteers%20helping%20families%2C%20colorful%20tents%2C%20educational%20materials%2C%20tropical%20sunlight%2C%20warm%20community%20spirit%2C%20documentary%20style&width=1600&height=800&seq=hero-outreach&orientation=landscape',
};

export const outreachStats = [
  { value: '1,000+', label: 'Community Members Reached' },
  { value: '15+', label: 'Neighborhoods Served' },
  { value: '40+', label: 'Outreach Events' },
  { value: '100+', label: 'Youth Volunteers Mobilized' },
];

export const initiatives = [
  {
    id: 'mobile-learning',
    title: 'Mobile Learning Hub',
    description: 'A traveling classroom equipped with laptops and learning materials that visits underserved neighborhoods every weekend. Youth can drop in for free computer lessons, homework help, and educational activities.',
    impact: 'Served 8 neighborhoods monthly with 30-50 youth per session',
    icon: 'ri-bus-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mobile%20learning%20bus%20in%20Malaysian%20village%2C%20youth%20using%20laptops%20inside%2C%20colorful%20exterior%20with%20educational%20graphics%2C%20tropical%20setting%2C%20community%20gathering%2C%20bright%20daylight&width=800&height=800&seq=initiative-mobile-learning&orientation=squarish',
  },
  {
    id: 'family-tech',
    title: 'Family Tech Days',
    description: 'Monthly events where entire families are invited to learn digital skills together — from parents learning basic smartphone use to children exploring coding through games. Food and transportation assistance are provided.',
    impact: '300+ families participated across 12 events in 2025',
    icon: 'ri-parent-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Family%20tech%20day%20in%20Malaysian%20community%20center%2C%20parents%20and%20children%20using%20tablets%20together%2C%20intergenerational%20learning%2C%20warm%20atmosphere%2C%20colorful%20banners%2C%20joyful%20expressions&width=800&height=800&seq=initiative-family-tech&orientation=squarish',
  },
  {
    id: 'school-partnership',
    title: 'School Partnership Program',
    description: 'Collaborating with local secondary schools in Butterworth and surrounding areas to provide after-school computer clubs, career talks, and holiday workshops for students from low-income families.',
    impact: 'Partnered with 6 schools, reaching 500+ students annually',
    icon: 'ri-building-4-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=After%20school%20computer%20club%20in%20Malaysian%20secondary%20school%2C%20students%20working%20on%20laptops%2C%20teacher%20assisting%2C%20bright%20classroom%2C%20modern%20educational%20setting%2C%20engaged%20youth&width=800&height=800&seq=initiative-school-partnership&orientation=squarish',
  },
  {
    id: 'digital-inclusion',
    title: 'Digital Inclusion Drive',
    description: 'Collecting donated laptops and devices, refurbishing them with the help of our tech-savvy youth volunteers, and distributing them to families in need. Includes setup assistance and basic training for recipients.',
    impact: '150+ devices refurbished and distributed to date',
    icon: 'ri-computer-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Laptop%20donation%20drive%20with%20Malaysian%20volunteers%20refurbishing%20computers%2C%20tech%20workshop%2C%20organized%20equipment%2C%20community%20effort%2C%20bright%20workspace%2C%20collaborative%20spirit&width=800&height=800&seq=initiative-digital-inclusion&orientation=squarish',
  },
];

export const outreachGallery = [
  {
    title: 'Kampung Gajah Learning Session',
    description: 'Weekly computer literacy class for youth in the Kampung Gajah community.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20learning%20computers%20in%20Malaysian%20village%20setting%2C%20outdoor%20canopy%2C%20laptops%20on%20tables%2C%20tropical%20greenery%2C%20community%20learning%2C%20bright%20daylight%2C%20documentary%20style&width=800&height=600&seq=gallery-0&orientation=landscape',
  },
  {
    title: 'Ramadan Distribution 2025',
    description: 'Food packages and school supplies distributed to 200 families during Ramadan.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Volunteers%20distributing%20food%20packages%20in%20Malaysian%20neighborhood%2C%20Ramadan%20spirit%2C%20smiling%20families%2C%20community%20gathering%2C%20warm%20atmosphere%2C%20documentary%20photography&width=800&height=600&seq=gallery-1&orientation=landscape',
  },
  {
    title: 'School Holiday Workshop',
    description: 'Two-day coding and robotics workshop during the school holidays.',
    imageUrl: 'https://readdy.ai/api/search-image?query=School%20holiday%20coding%20workshop%2C%20Malaysian%20children%20building%20robots%2C%20colorful%20classroom%2C%20excited%20expressions%2C%20hands-on%20learning%2C%20bright%20modern%20setting&width=800&height=600&seq=gallery-2&orientation=landscape',
  },
];

export const outreachTestimonials = [
  {
    name: 'Mak Cik Salmah',
    role: 'Kampung Gajah Resident',
    text: 'The mobile learning hub comes to our neighborhood every Saturday. My grandchildren have learned so much about computers — things I could never teach them myself. We are truly grateful.',
  },
  {
    name: 'Cikgu Azman',
    role: 'Teacher, SMK Butterworth',
    text: 'The school partnership program has been transformative for our students. The after-school club gives them access to technology and guidance they wouldn\'t otherwise have. Attendance is always full.',
  },
];